export const RTStatesEnum = {
  SERIALIZZATO: 'SERIALIZZATO',
  CENSITO: 'CENSITO',
  FISCALIZZATO: 'FISCALIZZATO',
  ATTIVATO: 'ATTIVATO',
  IN_SERVIZIO: 'IN_SERVIZIO',
  FUORI_SERVIZIO: 'FUORI_SERVIZIO',
  DISATTIVATO: 'DISATTIVATO',
  DISMESSO: 'DISMESSO',
}
